export default __webpack_public_path__ + "31.01.2019-LifeTime_ermöglicht_sichere_eRezept-Übertragung_im_Pilotprojektcde1ccb82be1d823c64dc4c22ea4c05f.pdf";